import { RefObject, createContext, useContext } from 'react';

export const StackContext = createContext<{
  stackIdx: number;
}>({
  stackIdx: 0,
});
export const StackContextRef = createContext<
  RefObject<{
    stackIdx: number;
  }>
>({ current: { stackIdx: 0 } });

export function useStackContext(): { stackIdx: number } {
  return useContext(StackContext);
}

export function useStackContextRef(): RefObject<{ stackIdx: number }> {
  return useContext(StackContextRef);
}
